/**
 * styles meant to address accessibility issues with our themes color contrast
 * @param theme current theme selected by user
 * @param isDarkTheme whether that theme is dark mode or not
 * @returns css styles appropriate to a Link object
 */
export const linkStyles = (theme, isDarkTheme) => {
    return {
        root: {
            textDecoration: 'underline',
            // need this level of specificity to override Fluent UI's default focus style to solve this a11y task https://dev.azure.com/msazure/One/_workitems/edit/26219884
            ':global(.ms-Link.ms-Link:focus)': {
                boxShadow: 'none',
                outline: `${theme.palette.neutralSecondary} auto 1px`,
            },
        },
    };
};
// const linkStyleSettings = (theme: ITheme, isDarkTheme?: boolean): IStyle => {
//   const { palette, semanticColors } = theme;
//   return {
//     color: isDarkTheme ? palette.themeDarker : semanticColors.link,
//     fontWeight: isDarkTheme ? FontWeights.semibold : '',
//     ':hover, :focus': {
//       color: semanticColors.linkHovered,
//     },
//   };
// };
